import { createFileRoute } from '@tanstack/react-router'

import { useShellClient } from '@/components/clients/shell-client'
import { Frame } from '@/components/frame'
import { ClientReminders } from '@/components/reminders/client-reminders'

export const Route = createFileRoute('/_app/clients/$clientId/relances')({
  component: ClientRemindersPage,
})

function ClientRemindersPage() {
  const client = useShellClient()
  return (
    <Frame>
      <ClientReminders clientId={client.id} clientName={client.name} />
    </Frame>
  )
}
